import React from 'react';
import { Icon, Spin } from 'antd';


/**
 * @component
 * @name CustomDropdownRender
 * @description It's the dropdown appears showing info
 * when a user didn't select a previous option but proceeds to the next option in pickup/delivery section dropdowns on Form page. 
 * It also shows a spinner when ports json is empty in the [Custom dropdown]{@link CustomDropdown} on search page.
 * @param {Object} props Component props
 * @param {boolean} props.showSpin Whether to show a spin loader
 * @param {string} props.text for showing info text in dropdown- for example, select country first, select location type first
 */
const CustomDropdownRender = (props) => {
  const text = props.text;
  const showSpin = props.showSpin;
  // console.log({ text, showSpin });

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',

        // background: 'white',
        // borderRadius: '4px',
        // boxShadow: '0 0 3px #ccc',
      }}
    >
      {/* for showing text */}
      {text && (
        <div
          style={{
            wordWrap: 'break-word',
            padding: '4px',
          }}
        >
          {text}
        </div>
      )}
      {/* for showing spin loader */}
      {showSpin && (
        <Spin
          indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
        />
      )}
    </div>
  );
};

export default CustomDropdownRender;
